import {URLS} from "./app-urls";
import {AbstractService, Expands, Filters} from "./abstract-service";
import {trackPromise} from "react-promise-tracker";
import Api from "./api-config";
import {AxiosResponse} from "axios";
import {Amortization, AmortizationClient} from "../models/basic/amortization";
import {Paginated, PaginatedResult} from "../models/default/paginated-result";

export type ImportAmortizationFilter = Filters & {
    years?: string,
    client?: string,
};

export class ImportAmortizationService extends AbstractService<Amortization> {

    constructor() {
        super(URLS.IMPORT_AMORTIZATION);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if (processedFilter?.client === "0") {
            delete processedFilter.client;
        }

        if(processedFilter.years) {
            if(!processedFilter.years) {
                delete processedFilter.years;
            }
        }

        return processedFilter;
    }

    async listYears(): Promise<AxiosResponse<{ years: number[] }>> {
        const path = `${this.path}list_years/`;
        return await trackPromise(Api.get(path));
    }

    async listClients(filters?: Filters, expands?: Expands, pagination?: Paginated): Promise<AxiosResponse<PaginatedResult<AmortizationClient>>> {
        const path = `${this.path}list_clients/`;
        const allParams = this.processParameters(filters, expands, pagination);
        return await trackPromise(Api.get(path, {params: allParams} ));
    }

}
